import { Thumbnail } from '@wix/design-system';
import { useSiteImages } from 'hooks/useSiteImages';
import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import styles from '../SelectImageStep.scss';
import { useMockupStore } from 'stores/mockupStore';

type Props = {
  onItemClick: (mediaUrl: string) => void;
};

const SKELETON_ITEM_COUNT = 8;

export const SelectImageStepOptions: FC<Props> = ({ onItemClick }) => {
  const mediaUrl = useAppStore((state) => state.mediaUrl);

  const isLoading = useMockupStore((state) => state.isLoading);
  const { images, isLoading: isSiteImagesLoading } = useSiteImages();

  if (isSiteImagesLoading) {
    return (
      <div className={styles.selectImageStepOptions} aria-busy="true" aria-live="polite">
        {[...Array.from({ length: SKELETON_ITEM_COUNT })].map((_, index) => (
          <div key={index} className={styles.selectImageStepOptionsItem}>
            <div className={styles.selectImageStepOptionsItemSkeleton} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.selectImageStepOptions}>
      {images.map((image) => {
        const isSelected = mediaUrl === image.imageUrl;
        return (
          <Thumbnail
            disabled={isLoading && !isSelected}
            selected={isSelected}
            key={image.id}
            onClick={() => {
              onItemClick(image.imageUrl);
            }}
          >
            <div className={styles.selectImageStepOptionsItem}>
              <img src={image.thumbnailUrl} alt={image.id} />
            </div>
          </Thumbnail>
        );
      })}
    </div>
  );
};
